module.exports = __webpack_public_path__ + "static/img/product_images_23_h5_zh.4a23013.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_23_h5_zh.png
// module id = zOJr
// module chunks = 34